import app from 'flarum/forum/app';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import {ApiPayloadPlural} from 'flarum/common/Store';
import Discussion from 'flarum/common/models/Discussion';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Tooltip from 'flarum/common/components/Tooltip';
import Album from '../models/Album';

const translationPrefix = 'kilowhat-cimaise.forum.attach-album-modal.';

interface AttachAlbumModalAttrs extends IInternalModalAttrs {
    discussion: Discussion
}

export default class AttachAlbumModal extends Modal<AttachAlbumModalAttrs> {
    album!: Album | null
    searchQuery: string = ''
    searching: boolean = false
    searchResults: Album[] | null = null

    oninit(vnode: any) {
        super.oninit(vnode);

        this.album = this.attrs.discussion.cimaiseAlbum() || null;
    }

    className() {
        return 'Modal--small AttachAlbumModal';
    }

    title() {
        return app.translator.trans(translationPrefix + 'title', {
            title: this.attrs.discussion.title(),
        });
    }

    content() {
        // Don't use .Modal-body because buttons are too difficult to see and changing background makes inputs invisible
        return m('.Modal-footer', [
            m('.Form-group', [
                app.translator.trans(translationPrefix + 'selected'),
                ' ',
                this.album ? this.album.title() : m('em', app.translator.trans(translationPrefix + 'none-selected')),
                this.album ? Tooltip.component({
                    text: app.translator.trans(translationPrefix + 'unselect')
                }, Button.component({
                    className: 'Button Button--icon',
                    icon: 'fas fa-times',
                    onclick: () => {
                        this.album = null;
                    },
                })) : null,
            ]),
            m('form.Form-group', {
                onsubmit: (event: Event) => {
                    event.preventDefault();

                    this.searching = true;

                    app.request<ApiPayloadPlural>({
                        url: app.forum.attribute('apiUrl') + '/cimaise/albums',
                        params: {
                            filter: {
                                q: this.searchQuery,
                            },
                            page: {
                                limit: 10,
                            },
                        },
                        errorHandler: this.onerror.bind(this),
                    }).then(albums => {
                        this.searchResults = app.store.pushPayload<Album[]>(albums);
                        this.searching = false;

                        m.redraw();
                    }, () => {
                        this.searchResults = [];
                        this.searching = false;
                    });
                },
            }, [
                m('input.FormControl', {
                    value: this.searchQuery,
                    onchange: (event: InputEvent) => {
                        this.searchQuery = (event.target as HTMLInputElement).value;
                    },
                }),
                Tooltip.component({
                    text: app.translator.trans(translationPrefix + 'search')
                }, Button.component({
                    type: 'submit',
                    className: 'Button Button--icon',
                    icon: 'fas fa-search'
                })),
            ]),
            this.searching ? m('.Form-group', LoadingIndicator.component()) : null,
            Array.isArray(this.searchResults) ? m('.Form-group', this.searchResults.length > 0 ? m('ul', this.searchResults.map(album => m('li', [
                album.title(),
                ' ',
                Tooltip.component({
                    text: app.translator.trans(translationPrefix + 'search')
                }, Button.component({
                    className: 'Button Button--icon',
                    icon: 'fas fa-check',
                    onclick: () => {
                        this.album = album;
                    },
                })),
            ]))) : m('em', app.translator.trans(translationPrefix + 'no-results'))) : null,
            m('.Form-group', Button.component({
                type: 'submit',
                className: 'Button Button--primary',
            }, app.translator.trans(translationPrefix + 'submit'))),
        ]);
    }

    onsubmit(event: Event) {
        event.preventDefault();

        this.loading = true;

        this.attrs.discussion.save({
            relationships: {
                cimaiseAlbum: this.album,
            },
        }, {
            errorHandler: this.onerror.bind(this),
        }).then(() => {
            this.hide();
        }, this.loaded.bind(this));
    }
}
